import React, {useState} from 'react';
import {Col, Image} from 'react-bootstrap';
import {BlogStyle, TextStyle} from '../assets/css/Styles';

/**
 * @param {Object} props - props for each blog component
 * @return {Component} each blog component
 */
function EachProject({...props}) {
  const [hover, setHover] = useState(false);
  return (
    <Col
      style={BlogStyle.eachBlogContainer}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}>
      <Image
        src={`${props.imgSrc}`}
        alt={`${props.imgSrc}`}
        style={BlogStyle.BlogImageStyle}
        rounded
      />
      <Col style={hover ? BlogStyle.blogTitleActive : BlogStyle.blogTitle}>
        <span style={TextStyle.subTitleTxt3}>{`${props.blogTitleTxt}`}
        </span>
      </Col>
      <Col style={BlogStyle.blogTextDiv}>
        <span style={TextStyle.normalTxt3}>{`${props.blogDate}`}</span>
      </Col>
      <Col style={BlogStyle.blogTextBorder} />
      <Col style={BlogStyle.blogText}>
        <span style={TextStyle.normalTxt2}>{`${props.blogTxt}`}</span>
      </Col>
    </Col>
  );
}

export default EachProject;
